import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import ScrollToTop from '../Commons/ScrollToTop';
import useWindowSize from '../../hooks/useWindowResize';

const Header = () => {
	const { width } = useWindowSize();

	const headerLinks = [
		{ title: 'headerMainPage', link: '/' },
		{ title: 'headerServices', link: '/services' },
		{ title: 'headerChart', link: '/chart' },
		{ title: 'headerPrice', link: '/Price' },
		{ title: 'headerGallery', link: '/gallery/list' },
		// { title: 'headerNews', link: '/news' },
		{ title: 'headerFAQ', link: '/faq' },
		{ title: 'headerAboutUs', link: '/about-us' },
		{ title: 'headerConcatUs', link: '/contact-us' },
	];

	const languages = [
		{ id: 'fa', title: 'فا', symbol: 'fa' },
		{ id: 'en', title: 'en', symbol: 'en' },
		// { id: 'ru', title: 'ru', symbol: 'ru' },
	];

	return (
		<header
			style={{
				position: 'sticky',
				top: 0,
				zIndex: 2000,
			}}
		>
			<ScrollToTop />
			{width < 1050 && <MobileHeader {...{ headerLinks, languages }} />}
			{width >= 1050 && <DesktopHeader {...{ headerLinks, languages }} />}
		</header>
	);
};

export default Header;
